import "../../../styles/requests.css";

function RequestItemList({ requestData }) {
  console.log(
    "REQUEST ITEM DATA:",
    requestData,
  );

  const getUserId = () => {
    const storedUserDetails =
      localStorage.getItem("userDetails");

    if (!storedUserDetails) {
      return null;
    }

    try {
      const parsedUserDetails =
        JSON.parse(storedUserDetails);

      return parsedUserDetails?.id || null;
    } catch (error) {
      console.error(
        "Failed to parse userDetails:",
        error,
      );

      return null;
    }
  };

  const handleViewBtnClick = (
    linkId,
    requestType,
  ) => {
    const userId = getUserId();

    const returnUrl = encodeURIComponent(
      window.location.href,
    );

    window.location.href =
      `/requests?p=view-request-detail` +
      `&t=${encodeURIComponent(requestType || "")}` +
      `&r=${encodeURIComponent(linkId || "")}` +
      `&u=${encodeURIComponent(userId || "")}` +
      `&r_url=${returnUrl}`;
  };

  const rawRequestType =
    requestData?.request_type || "";

  const normalizedRequestType =
    rawRequestType.toUpperCase();

  const isCcar =
    normalizedRequestType === "CCAR";

  const isEpr =
    normalizedRequestType === "EPR";

  const requestType = isEpr
    ? "Request"
    : rawRequestType;

  const warehouse =
    requestData?.warehouse || "N/A";

  const customerAuditReferenceNumber =
    requestData?.reference_number || "N/A";

  const getStatusClass = () => {
    switch (requestData?.status) {
      case "Approved":
        return "approved";

      case "Denied":
        return "denied";

      case "Cancelled":
        return "cancelled";

      default:
        return "pending";
    }
  };

  return (
    <div
      className="request-item--list-container"
      onClick={() =>
        handleViewBtnClick(
          /*
           * Keep using id because this is the ID
           * your original working navigation used.
           */
          requestData?.id,
          requestData?.request_type,
        )
      }
    >
      <div className="request-item--row">
        <div className="request--item-logo">
          <i
            className="fa fa-file-text-o fa-4x"
            aria-hidden="true"
          ></i>
        </div>

        <div>
          <div className="request-ref-no">
            <h1>
              {requestData?.request_id ||
                "N/A"}
            </h1>
          </div>

          <div className="request--detail">
            <div className="request--detail-item">
              <span>
                Request Type:&nbsp;
              </span>

              <span>
                {requestType || "N/A"}
              </span>
            </div>

            <div className="request--detail-item">
              <span>
                Date &amp; Time Requested:&nbsp;
              </span>

              <span>
                {requestData?.date || "N/A"}
              </span>
            </div>

            {isCcar ? (
              <>
                <div className="request--detail-item">
                  <span>
                    Warehouse:&nbsp;
                  </span>

                  <span>{warehouse}</span>
                </div>

                <div className="request--detail-item">
                  <span>
                    Customer / Audit Reference
                    No.:&nbsp;
                  </span>

                  <span>
                    {
                      customerAuditReferenceNumber
                    }
                  </span>
                </div>
              </>
            ) : isEpr ? (
              <div className="request--detail-item">
                <span>
                  Total Cost:&nbsp;
                </span>

                <span>
                  {requestData?.total_cost ||
                    "₱0.00"}
                </span>
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className="request--detail-status">
        <div
          className={`status ${getStatusClass()} request--item-approval-status`}
        >
          <span>
            {requestData?.status || "Pending"}
          </span>
        </div>
      </div>
    </div>
  );
}

export default RequestItemList;